function color (color) {
  if (!arguments.length) return this.__attrs__.color;
  if (Array.isArray(color)) {
    this.__attrs__.color = color;
  } else if (typeof color === 'string') {
    this.__attrs__.color = [color];
  }
  return this;
}

export default color;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/color.js